<template>
  <v-text-field
    class="search-text pt-2"
    v-model="searchDomainVal"
    placeholder="Search"
    clearable
    @click:clear="clearSearch"
    @keyup="searchFunction(1)"
  >
    <v-icon
      slot="append"
      color="#58E2C2"
      v-if="!searchDomainVal"
      >search</v-icon
    >
  </v-text-field>
</template>
<script>
const debounceTimeInMilliseconds = 800;
let debounce = require('lodash.debounce');
export default {
  name: 'SearchBar',
  data() {
    return {
      searchDomainVal: '',
    };
  },
  methods: {
    // To search for provided keyword in search bar
    searchFunction: debounce(function (pageNumber) {
      if (this.searchDomainVal === null) {
        this.searchDomainVal = '';
      }
      if (this.searchDomainVal === '') {
        this.$emit('clearSearch');
      } else {
        this.$emit('searchItem', {
          pageNumber,
          searchDomainVal: this.searchDomainVal,
        });
      }
    }, debounceTimeInMilliseconds),
    // To clear search bar
    clearSearch() {
      this.searchDomainVal = '';
      this.$emit('clearSearch');
    },
  },
};
</script>